import { useEffect, useState } from 'react';
import { authConfig } from '../utils/auth/authConfig';
import axios from 'axios';
import { IUser } from '../@types';

const validateSession = async (
  user: IUser | null,
  logout: () => Promise<void>
) => {
  const invalidSessionResponse = {
    isValidSession: false,
    behindOwnModem: false,
  };
  if (!user) return invalidSessionResponse;

  console.log('user in validateSession: ', user);
  try {
    const response = await axios({
      method: 'GET',
      url: `${process.env.GATSBY_IDM_API_URL}/auth/oauth/v2/validateSession?getLocation=true`,
      withCredentials: true,
      headers: {
        'x-client-id': authConfig.clientId,
        'x-access-token': user.access_token,
        'x-refresh-token': user.refresh_token,
        'x-context-token': user.context_token,
      },
    });

    const {
      isValidSession,
      location: { behindOwnModem },
    } = response.data;
    // Clears existing user data if it exists and there isn't a valid session
    // This can occur if a user logs out from another website, which invalidates the cookies and tokens
    if (!isValidSession && user) {
      await logout();
      return invalidSessionResponse;
    }
    return { isValidSession, behindOwnModem };
  } catch (error: any) {
    console.log('Validate Session API Error: ', error);
    return invalidSessionResponse;
  }
};

const useValidateSession = (
  user: IUser | null,
  logout: () => Promise<void>
) => {
  const [isValidSession, setIsValidSession] = useState<boolean>(false);
  const [isValidatingSession, setIsValidatingSession] =
    useState<boolean>(false);
  const [behindOwnModem, setBehindOwnModem] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      setIsValidatingSession(true);
      const { isValidSession: isSessionValid, behindOwnModem } =
        await validateSession(user, logout);
      setIsValidSession(isSessionValid);
      setBehindOwnModem(behindOwnModem);
      setIsValidatingSession(false);
    })();
  }, [user]);

  return { isValidSession, isValidatingSession, behindOwnModem };
};

export default useValidateSession;
